import { schema } from 'normalizr';
import { QuestionChildren } from './question';
import thirdLevelChildContent from './thirdLevelChildContent';

const subContent = new schema.Entity(
  'contents',
  {
    children: [thirdLevelChildContent]
  },
  {
    processStrategy: (value: any, parent: any, key: string) => {
      const result = {
        ...value,
        sectionKey: parent.sectionKey,
        parentKey: parent.parentKey,
        value: undefined
      }

      if (result.children as QuestionChildren) {
        if (key !== 'children' && result.children as QuestionChildren) {
          result.children = result.children.map((item: any) => item.id) as Array<string>;
        }
      }

      switch (key) {
        case 'instructions':
        case 'hints':
        case 'correctFeedback':
        case 'incorrectFeedback':
        case 'children':
          result.url = `${parent.sectionKey}/${parent.parentKey}/${value.id}.html`
          break;
        case 'questionContent':
          result.url = `${parent.sectionId}/${parent.id}/content.html`;
          break;
        default:
          throw new Error('Content entity key is not supported');
      }
      return result;
    }
  }
);

export default subContent;
